import React from 'react';
import { List } from 'react-native-paper';
import { Trans } from '@lingui/macro';
import { useNavigation } from '@react-navigation/native';

import Avatar from '@src/components/Avatar';
import Row from '@src/components/Row';
import Separator from '@src/components/Separator';
import { Body1, Subtitle1 } from '@src/components/Typography';
import { Rank } from '@src/types';

type Props = {
  item: Rank;
  index: number;
};

const Component: React.FC<Props> = ({ item, index }) => {
  const navigation = useNavigation();
  const handlePress = React.useCallback(
    // @ts-ignore
    () => navigation.push('Profile', { id: item.user.id }),
    [item.user.id, navigation]
  );

  return (
    <List.Item
      onPress={handlePress}
      title={item.user.name}
      description={item.user.username}
      left={(props) => (
        <Row style={props.style}>
          <Body1>{index}</Body1>
          <Separator />
          <Avatar source={item.user.avatar} size={32} />
        </Row>
      )}
      right={(props) => (
        <Row style={props.style}>
          <Body1>{item.score}</Body1>
          <Separator />
          <Subtitle1>
            <Trans>score</Trans>
          </Subtitle1>
        </Row>
      )}
    />
  );
};

Component.displayName = 'RankCard';

export default React.memo(Component);
